import { Link } from 'react-router-dom';
import type { SupportTicket } from '../../api';
import {
  SUPPORT_STATUS_LABELS,
  categoryLabel,
  formatSupportDate,
  ratingLabel,
} from './supportLabels';

export const SupportStatusChip = ({ status }: { status: SupportTicket['status'] }) => (
  <span className={`support-chip support-chip--${status}`}>
    {SUPPORT_STATUS_LABELS[status]}
  </span>
);

const SupportTicketList = ({
  tickets,
  showAuthor = false,
}: {
  tickets: SupportTicket[];
  showAuthor?: boolean;
}) => (
  <ul className="support-list">
    {tickets.map((ticket) => {
      const meta = [categoryLabel(ticket.category)];
      if (showAuthor && ticket.author) {
        meta.push(`${ticket.author.name} (${ticket.author.login})`);
      }
      if (showAuthor && ticket.club_name) meta.push(ticket.club_name);
      if (showAuthor && ticket.rating) meta.push(`оценка ${ratingLabel(ticket.rating)}`);
      return (
        <li key={ticket.id}>
          <Link
            to={`/support/${ticket.id}`}
            className="support-ticket-card ui-panel ui-panel-tight"
          >
            <span className="support-ticket-title">
              {ticket.unread ? (
                <>
                  <span className="support-unread-dot" aria-hidden="true" />
                  <span className="support-visually-hidden">Непрочитано:</span>
                </>
              ) : null}
              {ticket.subject}
            </span>
            <span className="support-ticket-meta">
              № {ticket.id} · {meta.join(' · ')}
            </span>
            <span className="support-ticket-side">
              <SupportStatusChip status={ticket.status} />
              <time dateTime={ticket.updated_at}>
                {formatSupportDate(ticket.updated_at)}
              </time>
            </span>
          </Link>
        </li>
      );
    })}
  </ul>
);

export default SupportTicketList;
